export default {
    props: {
        currencyDisplay: {
            type: String,
            default: 'default',
            validator: (val) => ['default', 'space_base'].includes(val)
        }
    }
}